export default __webpack_public_path__ + "static/media/adminEmployee.e02dea12.svg";